import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { EditableDBItemV3, ModuleFE_MouseInteractivity, mouseInteractivity_PopUp, ProtoComponent } from '@nu-art/thunderstorm-frontend/index';
import { TS_HorizontalWorkspace, TS_Workspace } from '@nu-art/ts-workspace-frontend/index';
import { getAdvisorContextManagerSearchItems, workspaceKey_AdvisorContextEditor } from './consts.js';
import { SearchSelector_BaseManagerUI } from '@app/styles';
import { cloneObj, DefaultNewItemId, exists, resolveContent } from '@nu-art/ts-common';
import { ModuleFE_AdvisorSnippet, ModuleFE_AdvisorWizard } from '../../_entity.js';
import { cleanAdvisorSnippet, DBDef_AdvisorSnippet, DBDef_AdvisorWizard } from '@app/advisor-content-shared';
import { Editor_AdvisorWizard } from './editors/Editor_AdvisorWizard.js';
import { Editor_AdvisorSnippet } from './editors/Editor_AdvisorSnippet.js';
import './Page_AdvisorEditor.scss';
export class Page_AdvisorContext extends ProtoComponent {
    static defaultProps = {
        keys: ['selected', 'searchItem'],
    };
    // ######################## Life Cycle ########################
    deriveStateFromProps(nextProps, state) {
        state.searchItems ??= getAdvisorContextManagerSearchItems();
        //Get selectedSearchItem from url
        const selected = this.getQueryParam('selected', {});
        //Get selected search item
        state.selectedSearchItem = undefined;
        for (const searchItem of state.searchItems) {
            const selectedId = selected[searchItem.type];
            if (!exists(selectedId))
                continue;
            state.selectedSearchItem = { type: searchItem.type, id: selectedId };
            break;
        }
        return state;
    }
    // ######################## Logic ########################
    onSearchItemSelected = (item) => {
        const selected = { ...this.getQueryParam('selected', {}) };
        //Clear all selections under this manager
        this.state.searchItems.forEach(searchItem => delete selected[searchItem.type]);
        //Set the selected item
        selected[item.type] = item.id;
        this.setQueryParams({
            selected: selected,
            searchItem: item.type, //Switch the filters in the search panel to the item type
        });
    };
    createNewItem = (dbKey) => {
        ModuleFE_MouseInteractivity.hide(mouseInteractivity_PopUp);
        this.onSearchItemSelected({ type: dbKey, id: DefaultNewItemId });
    };
    getEditable = (module, newItemBase) => {
        const id = this.state.selectedSearchItem?.id;
        if (!id)
            return;
        const selectedItem = module.cache.unique(id) ?? cloneObj(resolveContent(newItemBase));
        const editable = new EditableDBItemV3(selectedItem, module);
        editable.setAutoSave(selectedItem._id !== DefaultNewItemId);
        editable.setDebounceTimeout(300);
        editable.setOnSaveCompleted(item => {
            //If the item is newly created, simulate selection for it
            if (id === DefaultNewItemId)
                return this.onSearchItemSelected({ type: module.dbDef.dbKey, id: item._id });
            //Item is not newly created, re-render
            this.forceUpdate();
        });
        return editable;
    };
    deselectItem = (dbKey) => {
        const selected = { ...this.getQueryParam('selected', {}) };
        delete selected[dbKey];
        this.setQueryParam('selected', selected);
    };
    // ######################## Render ########################
    render() {
        return _jsx(TS_Workspace, { workspaceKey: workspaceKey_AdvisorContextEditor, renderers: {
                horizontalSpace: TS_HorizontalWorkspace,
            }, instances: {
                list: () => this.renderList(),
                editor: () => this.renderEditor(),
            } });
    }
    renderList = () => {
        return _jsx(SearchSelector_BaseManagerUI, { buttons: [{
                    label: 'Add New',
                    action: (e) => {
                        const buttonBox = e.currentTarget.getBoundingClientRect();
                        const model = {
                            id: 'advisor-context-editor__add-new-popup',
                            originPos: {
                                x: buttonBox.x + buttonBox.width + 10,
                                y: buttonBox.y + (buttonBox.height / 2),
                            },
                            modalPos: { x: 1, y: 0 },
                            content: () => {
                                return _jsx(_Fragment, { children: this.state.searchItems.map(searchItem => _jsx("div", { onClick: () => this.createNewItem(searchItem.type), children: searchItem.entityLabel }, searchItem.type)) });
                            },
                        };
                        ModuleFE_MouseInteractivity.showContent(model);
                    }
                }], searchItems: this.state.searchItems, onSearchItemSelected: this.onSearchItemSelected, selectedItem: this.state.selectedSearchItem });
    };
    renderEditor = () => {
        switch (this.state.selectedSearchItem?.type) {
            case DBDef_AdvisorWizard.dbKey:
                return this.renderEditor_AdvisorWizard();
            case DBDef_AdvisorSnippet.dbKey:
                return this.renderEditor_AdvisorSnippet();
            default:
                return _jsx(_Fragment, {});
        }
    };
    renderEditor_AdvisorWizard = () => {
        const editable = this.getEditable(ModuleFE_AdvisorWizard, {});
        if (!editable)
            return _jsx(_Fragment, {});
        return _jsx(Editor_AdvisorWizard, { editable: editable, deselectWizard: () => this.deselectItem(DBDef_AdvisorWizard.dbKey) });
    };
    renderEditor_AdvisorSnippet = () => {
        const editable = this.getEditable(ModuleFE_AdvisorSnippet, cleanAdvisorSnippet);
        if (!editable)
            return _jsx(_Fragment, {});
        return _jsx(Editor_AdvisorSnippet, { editable: editable, deselectSnippet: () => this.deselectItem(DBDef_AdvisorSnippet.dbKey) });
    };
}
//# sourceMappingURL=Page_AdvisorContext.js.map